module.exports = __webpack_public_path__ + "static/media/landscape.f86e70d5.JPG";